import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "6BaUDz",
    defaultMessage: "Order discount",
    description: "placed order discount card header",
  },
  hint: {
    id: "32W1De",
    defaultMessage:
      "Changing the discount recalculates the order total. Payments already captured and invoices already issued are not changed.",
    description: "placed order discount card hint",
  },
  noDiscount: {
    id: "OYLm91",
    defaultMessage: "No discount",
    description: "placed order has no manual discount",
  },
});
